export const OTHER_SC_IDS = ['120', '122', '121', '123', '31', '97', '20', '117'];
